import React, { useState, useEffect } from "react"
import { useHistory, useLocation } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"

import { useTranslation } from "react-i18next"

import { Dimmer, Segment, Sidebar } from "semantic-ui-react"

import { hasEnoughPermissions } from "../config/permissions"
import { signOut } from "../ducks/profile"
import { closeMessage } from "../ducks/alerts"
import { testApi } from "../config/apiUrls"

import AlertsHolder from "../components/AlertsHolder"
import LoginPage from "./LoginPage"
import SidebarMenu from "../components/SidebarMenu"
import { SidebarMenuItem, sidebarMenuItems } from "../config/sidebarMenuItems"
import TopMenu from "../components/TopMenu"
import RegistrationPage from "./RegistrationPage"
import { apiGet } from "../utils/apiConnector"
import { NotificationContainer } from "react-notifications"

const Layout = (props) => {
  const dispatch = useDispatch()
  const history = useHistory()

  const { t } = useTranslation()

  const { profile, alerts } = useSelector((state) => ({
    profile: state.profile,
    alerts: state.alerts,
  }))

  const [sidebarOpened, setSidebarOpened] = useState(false)

  useEffect(() => {
    test()
    return () => {}
  }, [])

  const toggleSidebar = () => {
    setSidebarOpened(!sidebarOpened)
  }

  const navigateHome = () => {
    history.push("/")
    setSidebarOpened(false)
  }

  const onSignOut = () => {
    dispatch(signOut())
  }
  const test = () => {
    apiGet(testApi, {})
      .onStatus(
        (res) => {
          onSignOut()
        },
        401,
        400,
        500,
      )
      .onFail(() => {
        onSignOut()
      })
      .afterAll(() => {})
      .startSingle()
  }

  const onAlertClick = (id) => {
    dispatch(closeMessage(id))
  }

  const { children } = props

  const { pathname } = useLocation()

  if (!profile.signedIn) {
    return (
      <div>
        {
          //<AlertsHolder top alerts={alerts} onAlertClick={onAlertClick} />
        }
        <NotificationContainer />
        {pathname === "/registration" ? (
          <RegistrationPage />
        ) : (
          <>
            <LoginPage />
          </>
        )}
      </div>
    )
  }
  const sidebarMenuItemsList = sidebarMenuItems.filter(
    (item) =>
      // hasEnoughPermissions(profile.permissions, item.route.permissions),
      item,
  )
  sidebarMenuItemsList.push(SidebarMenuItem(null, t("Logout"), null, onSignOut))

  return (
    <div style={{ height: "100%" }}>
      <NotificationContainer />
      <TopMenu
        profile={profile}
        toggleSidebar={toggleSidebar}
        onSignOut={onSignOut}
        navigateHome={navigateHome}
      />
      <div style={{ height: "100%" }}>
        <Sidebar.Pushable as="div">
          <SidebarMenu
            visible={sidebarOpened}
            menuItems={sidebarMenuItemsList}
            toggleSidebar={toggleSidebar}
          />
          <Sidebar.Pusher>
            <Segment basic>
              <AlertsHolder alerts={alerts} onAlertClick={onAlertClick} />
              <div style={{ marginTop: 47 }}>{children}</div>
            </Segment>
            <Dimmer
              className="sidebar-dimmer"
              active={sidebarOpened}
              onClick={toggleSidebar}
            />
          </Sidebar.Pusher>
        </Sidebar.Pushable>
      </div>
    </div>
  )
}

export default Layout
